import React, { useEffect, useState } from 'react';
import Header from './components/header/header.jsx';
import TopNav from './components/top-nav/top-nav.jsx';
import Sidebar from './components/sidebar/sidebar.jsx';
import Content from './components/content/content.jsx';
import Footer from './components/footer/footer.jsx';
import ThemePanel from './components/theme-panel/theme-panel.jsx';
import { AppSettings } from './config/app-settings.js';

function App() {
	var defaultOptions = {
		appTheme: 'theme-cyan',
		appHeaderNone: true,
		appSidebarNone: true,
		appSidebarCollapsed: false,
		appContentNone: false,
		appContentClass: '',
		appContentFullHeight: false,
		appBoxedLayout: false,
		appFooter: false,
		appTopNav: false,
		appThemePanelToggled: false,
		appHasScroll: false
	};
	const [appHeaderNone, setAppHeaderNone] = useState(defaultOptions.appHeaderNone);
	const [appSidebarNone, setAppSidebarNone] = useState(defaultOptions.appSidebarNone);
	const [appSidebarCollapsed, setAppSidebarCollapsed] = useState(defaultOptions.appSidebarCollapsed);
	const [appContentNone, setAppContentNone] = useState(defaultOptions.appContentNone);
	const [appContentClass, setAppContentClass] = useState(defaultOptions.appContentClass);
	const [appContentFullHeight, setAppContentFullHeight] = useState(defaultOptions.appContentFullHeight);
	const [appBoxedLayout, setAppBoxedLayout] = useState(defaultOptions.appBoxedLayout);
	const [appFooter, setAppFooter] = useState(defaultOptions.appFooter);
	const [appTopNav, setAppTopNav] = useState(defaultOptions.appTopNav);
	const [appThemePanelToggled, setAppThemePanelToggled] = useState(defaultOptions.appThemePanelToggled);
	const [appHasScroll, setAppHasScroll] = useState(defaultOptions.appHasScroll);
	const [appVh100, setAppVh100] = useState(defaultOptions.appVh100);
	const providerValue = {
		setAppHeaderNone, 
		setAppSidebarNone, 
		setAppSidebarCollapsed, 
		setAppContentNone, 
		setAppContentClass,
		setAppContentFullHeight,
		setAppBoxedLayout,
		setAppFooter,
		setAppTopNav,
		appThemePanelToggled,
		setAppThemePanelToggled,
		setAppHasScroll,
		setAppVh100
	};
		
	var handleSetAppTheme = (value) => {
		if (value) {
			var newTheme = value;
			for (var x = 0; x < document.body.classList.length; x++) {
				if ((document.body.classList[x]).indexOf('theme-') > -1 && document.body.classList[x] !== newTheme) {
					document.body.classList.remove(document.body.classList[x]);
				}
			}
			
			if (localStorage && value) {
				localStorage.appTheme = value;
			}
			
			document.body.classList.add(newTheme);
			document.dispatchEvent(new Event('theme-reload'));
		}
	}
	
	useEffect(() => {
		if (defaultOptions.appTheme) {
			handleSetAppTheme(defaultOptions.appTheme);
		}
    
		if (localStorage) {
			if (typeof localStorage.getItem('appTheme') !== 'undefined') {
				handleSetAppTheme(localStorage.getItem('appTheme'));
			}
		}
		
		document.onscroll = function() {
			var doc = document.documentElement;
			var totalScroll = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
			var elm = document.querySelectorAll('.app')[0];
			
			if (elm) {
				if (totalScroll > 0) {
					setAppHasScroll(true);
				} else {
					setAppHasScroll(false);
				}
			}
		};
		
		// eslint-disable-next-line
  }, []);
	
	return (
		<AppSettings.Provider value={providerValue}>
			<div className={
				'app ' +
				(appBoxedLayout ? 'app-boxed-layout ' : '') + 
				(appContentFullHeight ? 'app-content-full-height ' : '') + 
				(appHeaderNone ? 'app-without-header ' : '') + 
				(appSidebarNone ? 'app-without-sidebar ' : '') + 
				(appSidebarCollapsed ? 'app-sidebar-collapsed ' : '') + 
				(appFooter ? 'app-footer-fixed ' : '') + 
				(appTopNav ? 'app-with-top-nav ' : '') + 
				(appHasScroll ? 'app-has-scroll ' : '') + 
				(appVh100 ? 'vh-100 ' : '')
			}>
				{!appHeaderNone && (<Header />)}
				{appTopNav && (<TopNav />)}
				{!appSidebarNone && (<Sidebar />)}
				{!appContentNone && (<Content className={appContentClass} />)}
				{appFooter && (<Footer />)}
				{/*<ThemePanel />*/}
			</div>
		</AppSettings.Provider>
	)
}

export default App;